import { useForm, Controller } from "react-hook-form";
import { Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { filterEmptyFields } from "../../utils/formUtils";
import userStatus from "../../utils/userStatusUtils";
import {
  Button,
  InputLabel,
  styled,
  DialogActions,
  DialogContent,
  IconButton,
  DialogTitle,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField,
  Typography,
  Dialog,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InputMask from "react-input-mask";
import Modal from "../../components/common/Modal";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import USER_PROFILE from "../../utils/userProfile";
import { AsyncSelectField } from "components/Fields";
import { adminAPI } from "services/admin";
import { useNotification } from "hooks/useNotification";

// let units = [];
// let channels = []
// const canais = [
//   "5968720c-56dc-4b56-8b44-ecde91e2d04e",
//   "Sesc Digital",
//   "Av Paulista Digital",
//   "Informação e educação popular",
// ];

//TODO: radio group buttons - se setar value, nao permite usuario escolher
//TODO: get users precisa vir com a lista de unidades com id e name (precis adicionar name - kennedy)

const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: "50%",
  width: 16,
  height: 16,
  boxShadow:
    theme.palette.mode === "dark"
      ? "0 0 0 1px rgb(16 22 26 / 40%)"
      : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
  backgroundColor: theme.palette.mode === "dark" ? "#394b59" : "#f5f8fa",
  backgroundImage:
    theme.palette.mode === "dark"
      ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
      : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
  ".Mui-focusVisible &": {
    outline: "2px auto rgba(19,124,189,.6)",
    outlineOffset: 2,
  },
  "input:hover ~ &": {
    backgroundColor: theme.palette.mode === "dark" ? "#30404d" : "#ebf1f5",
  },
  "input:disabled ~ &": {
    boxShadow: "none",
    background:
      theme.palette.mode === "dark"
        ? "rgba(57,75,89,.5)"
        : "rgba(206,217,224,.5)",
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: "#137cbd",
  backgroundImage:
    "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
  "&:before": {
    display: "block",
    width: 16,
    height: 16,
    backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
    content: '""',
  },
  "input:hover ~ &": {
    backgroundColor: "#106ba3",
  },
});

function BpRadio(props) {
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      {...props}
    />
  );
}

function ModalUser(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [selectError, setSelectError] = useState(false);
  const [mask, setMask] = useState("(99) 99999-9999");
  const [selectedRole, setSelectedRole] = useState(null);
  const [confirmDialogAction, setConfirmDialogAction] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const { setNotify } = useNotification();
  const [isLoadingModalConfirmation, setIsLoadingModalConfirmation] =
    useState(false);
  const { showConfirmationButton } = useState(true);
  const [auth] = useState(props.authenticatedUser);
  const [userProfile, setUserProfile] = useState();

  useEffect(() => {
    setUserProfile(auth.getIdToken().payload["custom:user_profile"]);
  }, [auth]);

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
    getValues,
    control,
  } = useForm({ mode: "onBlur" });

  async function postData(bodyData) {
    setIsLoading(true);

    const session = auth;
    bodyData.createdBy = {
      userId: session.getIdToken().payload.sub,
      name: session.getIdToken().payload.username,
    }; //TODO: verificar se manda o name do cognito
    // bodyData.updatedBy = {"userId": session.getIdToken().payload.sub, "name": session.getIdToken().payload.name} //TODO: verificar se manda o name do cognito

    return adminAPI
      .post("/admin/users", {
        body: bodyData,
      })
      .then(() => {
        props.onClose();
        props.getUsers();
        setIsLoading(false);
        setNotify({
          isOpen: true,
          message: `Usuário criado com sucesso!`,
          type: "success",
          title: "Sucesso",
        });
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        // const errorJson = error.message || error.response.message;
        // const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: error.message || error.response.message,
          type: "error",
          title: "Ops! Algo deu errado...",
        });
      });
  }

  async function putData(bodyData) {
    setIsLoading(true);
    const session = auth;
    // const session = props.authenticatedUser
    const path = "/admin/users/" + props.user.userId;
    bodyData.createdBy = {
      userId: session.getIdToken().payload.sub,
      name: session.getIdToken().payload.username,
    }; //TODO: verificar se manda o name do cognito
    const data = {
      body: bodyData,
    };

    return adminAPI
      .put(path, data)
      .then(() => {
        closeModal();
        setIsLoading(false);
        props.getUsers();
        setNotify({
          isOpen: true,
          message: `Usuário "${props.user.name}" atualizado.`,
          type: "success",
          title: "Sucesso!",
        });
      })
      .catch((error) => {
        closeModal();
        setIsLoading(false);
        console.log(error);
        // const errorJson = error.request.response;
        // const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: error.message || error.response.message,
          type: "error",
          title: "Ops! Algo deu errado...",
        });
      });
  }

  async function deleteData() {
    setIsLoadingModalConfirmation(true);
    const path = `/admin/users/${props.user.userId}`;

    try {
      adminAPI.del(path).then(() =>
        setNotify({
          isOpen: true,
          message: `Usuário "${props.user.name}" removido!`,
          type: "success",
          title: "Sucesso!",
        })
      );
      setIsLoadingModalConfirmation(false);
      setConfirmDialogAction({ isOpen: false });
      props.onClose();
      props.getUsers();
    } catch (error) {
      console.log(error);
      // const errorJson = error.request.response;
      // const parseJson = JSON.parse(errorJson);
      setNotify({
        isOpen: true,
        message: error.message || error.response.message,
        type: "error",
        title: "Ops! Algo deu errado...",
      });
      setIsLoadingModalConfirmation(false);
    }
  }

  useEffect(() => {
    //On Modal Open
    if (props.open === true) {
      // Set initial values
      setSelectedRole(props.user.role);
      setValue("role", props.user.role);
      setValue("name", props.user.name ? props.user.name : "");
      setValue("email", props.user.email ? props.user.email : "");
      setValue("phoneNumber", props.user.phoneNumber ? props.user.phoneNumber : ""
      );
      // setValue("channels", props.user.channels ? props.user.channels.map((channel) => ({ channelId: channel.id })) : [])
      setValue(
        "channels",
        props.user.channels
          ? props.user.channels.map((channel) => ({
            value: channel.channelId,
            label: channel.name,
          }))
          : []
      );
      setValue(
        "units",
        props.user.units
          ? props.user.units.map((unit) => ({
            value: unit.unitId,
            label: unit.name,
          }))
          : []
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open, props.authenticatedUser]);

  const handleRoleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedRole(value);
    setValue("role", value);
  };

  const onSubmit = () => {
    const formValues = getValues();
    console.log(formValues)

    // Remove fields with empty values
    let filteredFormValues = filterEmptyFields(formValues);

    if (filteredFormValues.units)
      filteredFormValues.units = filteredFormValues.units.map((unit) => ({
        unitId: unit.value,
      })); //TODO o unit e o channel estao como o nome, mas o back espera o id deles

    if (filteredFormValues.channels)
      filteredFormValues.channels = filteredFormValues.channels.map(
        (channel) => ({ channelId: channel.value })
      );

    if (
      filteredFormValues.role !== "ADMIN" &&
      filteredFormValues.units === undefined &&
      filteredFormValues.channels === undefined
    ) {
      setSelectError(true);
    } else {
      setSelectError(false);
      if (filteredFormValues.role === "ADMIN") {
        delete filteredFormValues.channels;
        delete filteredFormValues.units;
      }
      if (props.action === "edit") {
        putData(filteredFormValues);
      } else if (props.action === "create") {
        postData(filteredFormValues)
          .then(() => {
            // Reset all fields after post
            closeModal();
            // setActive(undefined)
          })
          .catch((error) => {
            console.log(error);
            //TODO: o que acontece se der erro na inserção?
          });
      }
    }
  };

  const roleAdminProfile = [
    { name: "Editor", value: "EDITOR" },
    { name: "Gestor", value: "MANAGER" },
    { name: "Administrador", value: "ADMIN" },
  ];
  const roleGestorProfile = [
    { name: "Editor", value: "EDITOR" },
    { name: "Gestor", value: "MANAGER" },
  ];

  function closeModal() {
    reset();
    setSelectedRole(null);
    setSelectError(false);
    // setSelectedName('')
    props.onClose();
  }
  return (
    <>
      <Dialog open={props.open} onClose={closeModal}>
        <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Form onSubmit={handleSubmit(onSubmit)} style={{ width: 480 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingTop: 12,
            }}
          >
            <DialogTitle
              style={{ lineHeight: 0, color: "rgba(16, 24, 40, 1)" }}
            >
              {props.action === "edit" ? "Editar usuário" : "Criar usuário"}
            </DialogTitle>
            {/* <ButtonGroup style={{ marginRight: 50 }}>
            <Button
              variant="outlined"
              className={`btn ${active ? "activated" : ""}`}
              onClick={() => handleActive(true)}
            >
              Ativo
            </Button>
            <Button
              className={`btn ${active === false && active !== undefined ? "activated" : ""}`}
              onClick={() => handleActive(false)}
            >
              Inativo
            </Button>
          </ButtonGroup> */}
          </div>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>

          <Typography
            style={{ paddingRight: 24, paddingTop: 4, paddingLeft: 24 }}
          >
            Preencha as informações do usuário. <span style={{ marginLeft:5, padding: 6, borderRadius: '18%', backgroundColor:`${props.user.status === "ACTIVE" ? '#4dd80d': props.user.status === "INACTIVE" ? '#e04206' : props.user.status === "PENDING" ? '#b0aaa8' : ""}`, fontSize: '12px', fontWeight: 'bold'}}>{userStatus[props.user.status]}</span>
          </Typography>
          <DialogContent>
            <Form.Group className="mb-3" controlId="formName">
              <div className="label-content">
                <label className="max-char-name">40 caracteres</label>
                <InputLabel className="form-label" htmlFor="name">
                  Nome
                </InputLabel>
              </div>

              <Controller
                name={"name"}
                control={control}
                rules={{
                  required: "O nome é obrigatório.",
                  minLength: { value: 3, message: "Mínimo de 3 caracteres" },
                  maxLength: { value: 40, message: "Máximo de 40 caracteres" },
                }}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { error },
                }) => (
                  <TextField
                    helperText={
                      error ? (
                        <span style={{ fontSize: "16px" }}>
                          {" "}
                          {error.message}{" "}
                        </span>
                      ) : null
                    }
                    error={!!error}
                    onChange={(e) => {
                      onChange(e);
                      // setSelectedName(e.target.value)
                    }}
                    value={value}
                    fullWidth
                    placeholder="Digite o nome"
                    variant="standard"
                    onBlur={onBlur}
                    InputProps={{
                          readOnly: auth.getIdToken().payload.sub === props.user.userId,
                    }}
                    id="user_name"
                  />
                )}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formEmail">
              <InputLabel className="form-label" htmlFor="email">
                Email
              </InputLabel>
              <Controller
                name={"email"}
                control={control}
                rules={{
                  required: "O email é obrigatório.",
                  pattern: {
                    value:
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    message: "Email com formato inválido.",
                  },
                }}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { error },
                }) => (
                  <TextField
                    helperText={
                      error ? (
                        <span style={{ fontSize: "16px" }}>
                          {" "}
                          {error.message}{" "}
                        </span>
                      ) : null
                    }
                    error={!!error}
                    onChange={(e) => {
                      onChange(e);
                    }}
                    value={value}
                    fullWidth
                    placeholder="Digite o email"
                    variant="standard"
                    onBlur={onBlur}
                    disabled={props.action === "edit" ? true : false}
                    id="user_email"
                  />
                )}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formRole" >
              <InputLabel className="form-label" htmlFor="role">
                Perfil
              </InputLabel>

              <RadioGroup
                aria-labelledby="radio-buttons-group-label"
                onChange={handleRoleChange}
                value={selectedRole || ""}
                name="radio-buttons-group"
                id="user_role"
              >
                {userProfile === USER_PROFILE.ADMIN
                  ? roleAdminProfile.map((role) => (
                    <FormControlLabel
                      key={role.name}
                      value={role.value}
                      control={<BpRadio />}
                      label={role.name}
                      {...register("role", { required: true })}
                      aria-invalid={errors.role ? "true" : "false"}
                      disabled = {auth.getIdToken().payload.sub === props.user.userId}
                    />
                  ))
                  : roleGestorProfile.map((role) => (
                    <FormControlLabel
                      key={role.name}
                      value={role.value}
                      control={<BpRadio />}
                      label={role.name}
                      {...register("role", { required: true })}
                      aria-invalid={errors.role ? "true" : "false"}
                      disabled= {auth.getIdToken().payload.sub === props.user.userId}   
                    />
                  ))}
              </RadioGroup>
              {errors.role?.type === "required" && (
                <p className="error" role="alert">
                  O perfil é obrigatório
                </p>
              )}
            </Form.Group>

            <Form.Group
              className="mb-3"
              style={{ height: "auto" }}
              controlId="formUnit"
            >
              <InputLabel
                className="form-label"
                id="select-standard-label"
                htmlFor="units"
              >
                Unidades
              </InputLabel>
              <AsyncSelectField
                id="units"
                name="units"
                isMulti
                placeholder="Buscar..."
                control={control}
                url="/admin/units?performance=true&limit=10&name=#name&sortBy=name&offset=#offset"
                responseKey="unitList"
                isDisabled={(selectedRole === "ADMIN" ? true : false) || auth.getIdToken().payload.sub === props.user.userId}
                isOptionDisabled={(option) => option.deleted}
                onBlur={() => {
                  if (
                    getValues("units").length <= 0 ||
                    getValues("units") === undefined
                  ) {
                    setSelectError(true);
                  } else {
                    setSelectError(false);
                  }
                }}
              />
            </Form.Group>

            <Form.Group
              className="mb-3"
              style={{ height: "auto" }}
              controlId="formChannel"
            >
              <InputLabel
                className="form-label"
                id="select-standard-label"
                htmlFor="channels"
              >
                Canais
              </InputLabel>

              <AsyncSelectField
                id="channels"
                name="channels"
                isMulti
                placeholder="Buscar..."
                isDisabled={(selectedRole === "ADMIN" ? true : false) || auth.getIdToken().payload.sub === props.user.userId}
                isOptionDisabled={(option) => option.deleted}
                control={control}
                url="/admin/channels?performance=true&limit=10&name=#name&sortBy=name&offset=#offset"
                responseKey="channelList"
                onBlur={() => {
                  if (
                    getValues("channels").length <= 0 ||
                    getValues("channels") === undefined
                  ) {
                    setSelectError(true);
                  } else {
                    setSelectError(false);
                  }
                }}
              />

              {selectError && (
                <p className="error" role="alert">
                  Unidade ou Canal é obrigatório.
                </p>
              )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formName" >
              <div className="label-content">
                <label className="max-char-name">Opcional</label>
                <InputLabel className="form-label" htmlFor="phoneNumber">
                  Telefone
                </InputLabel>
              </div>
              <Controller
                name={"phoneNumber"}
                control={control}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { error, invalid, isTouched, isDirty },
                  formState,
                }) => (
                  <InputMask
                    mask={mask}
                    name="phoneNumber"
                    onBlur={(e) => {
                      if (e.target.value.replace("_", "").length === 14) {
                        setMask("(99) 9999-9999");
                      }
                    }}
                    onFocus={(e) => {
                      if (e.target.value.replace("_", "").length === 14) {
                        setMask("(99) 99999-9999");
                      }
                    }}

                    onChange={(e) => {
                      onChange(e);
                    }}
                    value={value}
                  >
                    {(inputProps) => (
                      <TextField
                        id="user_phone"
                        fullWidth
                        InputProps={{
                            readOnly: auth.getIdToken().payload.sub === props.user.userId,
                        }}
                        placeholder="Digite telefone com DDD"
                        variant="standard"
                        type="tel"
                        {...inputProps}
                      />
                    )}
                  </InputMask>
                )}
              />
            </Form.Group>
          </DialogContent>
          {auth.getIdToken().payload.sub !== props.user.userId && (
          <DialogActions style={{ padding: "0 24px 24px" }}>
            {props.action === "edit" && (
              <Button
                style={{
                  color: "rgba(52, 64, 84, 1)",
                  borderRadius: 8,
                  background: "rgba(255, 255, 255, 1)",
                  borderColor: "rgba(208, 213, 221, 1)",
                  padding: "10px 18px",
                  marginLeft: 12,
                }}
                onClick={() =>
                  setConfirmDialogAction({
                    isOpen: true,
                    title: `Remover ${props.user.name === undefined
                      ? props.user.email
                      : props.user.name
                      }?`,
                    subTitle: `Você está removendo o usuário permanentemente, clique remover para confirmar.`,
                    confirmTextButton: "Remover",
                    color: "error",
                    children: (
                      <div className="modalRemoveItem">
                        <DeleteOutlineOutlinedIcon
                          color="error"
                          fontSize="8px"
                        />
                      </div>
                    ),
                    onConfirm: () => {
                      deleteData();
                    },
                    showConfirmationButton: { showConfirmationButton },
                    closeTextButton: "Cancelar",
                  })
                }
                variant="contained"
                id="romove_btn"
              >
                Remover
              </Button>
            )}
            <Button
              style={{
                marginLeft: 12,
                color: "rgba(52, 64, 84, 1)",
                borderRadius: 8,
                background: "rgba(255, 255, 255, 1)",
                borderColor: "rgba(208, 213, 221, 1)",
                padding: "10px 18px",
              }}
              variant="contained"
              onClick={() => {
                closeModal();
              }}
              id="cancel_btn"
            >
              Cancelar
            </Button>
            <Button
              style={{
                color: "rgba(255, 255, 255, 1)",
                borderRadius: 8,
                marginLeft: 12,
                background: "rgba(19, 97, 164, 1)",
                borderColor: "rgba(19, 97, 164, 1)",
                padding: "10px 18px",
              }}
              variant="contained"
              type="submit"
              onClick={() => { }}
              id="save_btn"
            >
              Salvar
            </Button>
          </DialogActions>
          )}
        </Form>
        <Modal
          confirmDialogAction={confirmDialogAction}
          setConfirmDialogAction={setConfirmDialogAction}
          isLoadingModalConfirmation={isLoadingModalConfirmation}
          setIsLoadingModalConfirmation={setIsLoadingModalConfirmation}
          showConfirmationButton={showConfirmationButton}
        />
      </Dialog>
    </>
  );
}

export default ModalUser;
